module.exports = __webpack_public_path__ + "img/default-voucher.8ec97162.png";